import {
  checkSystemStatus,
  systemUnderMaintenance$,
} from '@euler/functions/maintenanceMode';
import { useIsAppActive } from '@euler/utils/hooks/useIsAppActive';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

export const MaintenanceScreen = memo(() => {
  const [visible, setVisible] = useState(false);
  const [checking, setChecking] = useState(false);
  const isActive = useIsAppActive();
  const prevActive = useRef(isActive);

  useEffect(() => {
    const sub = systemUnderMaintenance$.subscribe(value => {
      setVisible(value);
    });
    return () => sub.unsubscribe();
  }, []);

  useEffect(() => {
    if (isActive && !prevActive.current && visible) {
      void checkSystemStatus();
    }
    prevActive.current = isActive;
  }, [isActive, visible]);

  const handleCheck = useCallback(async () => {
    setChecking(true);
    try {
      await checkSystemStatus();
    } finally {
      setChecking(false);
    }
  }, []);

  if (!visible) return null;

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.icon}>🔧</Text>
        <Text style={styles.title}>系统维护中</Text>
        <Text style={styles.message}>系统正在进行维护升级，请稍后再试。</Text>
        <TouchableOpacity
          style={styles.button}
          onPress={handleCheck}
          disabled={checking}
          activeOpacity={0.7}
        >
          {checking ? (
            <ActivityIndicator color="#fff" size="small" />
          ) : (
            <Text style={styles.buttonText}>检查状态</Text>
          )}
        </TouchableOpacity>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 99999,
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    alignItems: 'center',
    paddingHorizontal: 40,
  },
  icon: {
    fontSize: 48,
    marginBottom: 20,
  },
  title: {
    fontSize: 22,
    fontWeight: '600',
    color: '#333',
    marginBottom: 12,
  },
  message: {
    fontSize: 15,
    color: '#666',
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 32,
  },
  button: {
    backgroundColor: '#007AFF',
    paddingHorizontal: 32,
    paddingVertical: 12,
    borderRadius: 8,
    minWidth: 120,
    alignItems: 'center',
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '500',
  },
});
